<script setup>
import SettingsForm from '@frontJs/components/forms/SettingsForm.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { googleAuthUrl, googleIsConnected, facebookConfiguration } = defineProps(
    {
        googleAuthUrl: {
            required: true,
            type: String,
        },
        googleIsConnected: {
            required: true,
            type: Boolean,
        },
        facebookConfiguration: {
            required: true,
            type: Object,
        },
    },
);

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>Paramètres - Datakepler</title>
    </Head>

    <PageTitle> Paramètres </PageTitle>

    <SettingsForm
        :google-auth-url="googleAuthUrl"
        :google-is-connected="googleIsConnected"
        :facebook-configuration="facebookConfiguration"
    />
</template>
